module.exports = __webpack_public_path__ + "img/07_choice 2.86733c0f.png";